import { AdminCard } from "../data-display/AdminCard";

interface AdminEmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  minHeight?: string;
}

const AdminEmptyState = ({
  icon = "ri-file-list-line",
  title,
  description,
  minHeight,
}: AdminEmptyStateProps) => {
  return (
    <AdminCard className="p-8 text-center" style={minHeight ? { minHeight } : undefined}>
      <i className={`${icon} text-slate-300 text-2xl`} />
      <p className="text-sm font-semibold text-slate-500 mt-3">{title}</p>
      {description && <p className="text-xs text-slate-400 mt-1">{description}</p>}
    </AdminCard>
  );
};

export default AdminEmptyState;
